import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import AddDatabaseModal from '../../components/database';
import DatabaseDetailModal from '../../components/alterDatabase';
import "./setting.css";
import { ApiOutlined, PlusOutlined } from '@ant-design/icons';

const Setting = () => {
  //增加的模态框
  const [useid] = useState(localStorage.getItem("token").split('+')[1])
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [databaseList, setDatabaseList] = useState(null);
  //修改的模态框
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);

  // const [dataIndex, setDataIndex] = useState(null);
  const showModal = () => {
    setIsModalVisible(true);
    // setDataIndex(index)
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleAdd = (values) => {
    console.log(values);
    setIsModalVisible(false);
    getDatabaseList(useid)
  };


  const handleModalOpen = (id) => {
    setModalVisible(true);
    setSelectedItemId(id);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setSelectedItemId(null);
  };

  const handleModalAdd = (values) => {
    console.log('Database added with values:', values);
    setModalVisible(false);
    getDatabaseList(useid)
  };

  const getDatabaseList = async (useid) => {
    try {
      // 使用fetch发起GET请求
      const response = await fetch(`//dai.caihuiltd.com/api/get-baseList/${useid}`, {
        method: 'GET',
        mode: 'cors',
      })
      // 检查响应状态
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      // 解析JSON数据
      const result = await response.json();
      // 将数据存储到状态中
      console.log(result);
      setDatabaseList(result.data);
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    }
  };


  useEffect(() => {
    getDatabaseList(useid)
  }, []);


  return (
    <div className='setting-container'>
      {databaseList && databaseList.map((item, index) => (
        <div key={index} className='databaselist'>
          <div className='sicon'>
            <ApiOutlined style={{ fontSize: '30px', color: '#08c' }} />
          </div>
          <div className='anme'>
            <h3>{item.database_name}</h3>
            <span>type: {item.type}</span>
          </div>
          <Button type="primary" onClick={() => handleModalOpen(item.id)}>
            Alter database
          </Button>
        </div>
      ))}
      <div className='databaselist' onClick={showModal}>
        <div className='sicon'>
          < PlusOutlined style={{ fontSize: '30px', color: '#08c' }} />
        </div>
        <div className='anme'>
          <h3>Click here to add database</h3>
        </div>
      </div>
      <AddDatabaseModal
        visible={isModalVisible}
        onCancel={handleCancel}
        onAdd={handleAdd}
      />
      <DatabaseDetailModal
        visible={modalVisible}
        onCancel={handleModalCancel}
        onAdd={handleModalAdd}
        itemId={selectedItemId}
      />
    </div>


  );
};

export default Setting;